<script lang='ts'>
export default {
  name: 'KkTextTypeSurveyAnswerDetail',
}
</script>

<script setup lang='ts'>

interface Props {
  answers: string[]
}

const props = defineProps<Props>()
</script>

<template>
  <ul class="answers">
    <li v-for="(answer, index) in props.answers"
        :key="`answer_${index}`"
    >
      {{ answer }}
    </li>
  </ul>
</template>

<style lang="scss" scoped>
@import '../../../../../../stylesheets/biz_spa/foundation/_var.scss';

.answers {
  max-height: 480px;
  border: 1px solid $color-base-c;
  border-radius: 4px;
  overflow-y: auto;

  li {
    padding: 16px 24px;
    overflow-wrap: break-word;
    white-space: pre-wrap;

    &:not(:last-child) {
      border-bottom: 1px solid $color-base-c;
    }
  }
}

</style>